


















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import ErrorResponseMixin from '@mixin/errorResponse';
import formFieldsMixin from '@mixin/formFields';
import UserDataFields from '@part/forms/UserDataFields';
import UserAdresFields from '@part/forms/UserAdresFields';
import UserAgeFields from '@part/forms/UserAgeFields';
import UserAccountFields from '@part/forms/UserAccountFields';
import UserTermsFields from '@part/forms/UserTermsFields';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({
    data() {
        return {
            post: {
                gender: 2,
                initials: '',
                lastname: '',
                lastname_prefix: '',
                function: '',
                validAge: '',
                street: '',
                postal: '',
                city: '',
                email: '',
                phone: '',
                password: '',
                terms: false,
            }
        };
    },

    mixins: [
        ErrorResponseMixin,
        formFieldsMixin,
    ],

    components: {
        UserDataFields,
        UserAdresFields,
        UserAgeFields,
        UserAccountFields,
        UserTermsFields,
    },

    methods: {
        submit() {
            this.validateFields()
        },

        validateSuccess() {
            if (this.post.validAge !== '1') {
                this.errorData = 'U moet ouder zijn dan 16 jaar om een aanvraag in te dienen';
                return;
            }

            this.$store.dispatch('user/register', {
                ...this.post
            }).then(response => {
                if (response instanceof Error) {
                    this.errorData = this.getErrorMessage(response);
                }
            });
        }
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class RegisterForm extends Vue {}

